import { Avatar } from '@mui/material';
import { styled } from '@mui/system';
import { useUser, useUserFields } from '../hooks/user';
import React, { useEffect } from 'react';

/* Essentia styled avatar.*/
export const StyledAvatar = styled(Avatar)(({ theme }) => ({
    width: '90px',
    height: '90px',
    color: theme.palette.common.white,
    '@media (max-width: 700px)': {
        width: '70px',
        height: '70px'
    }
}));

/** @component
 * Creates the EbabAvatar.
 * @param props
 * @returns {React.Element}
 * @constructor
 */
export const EbabAvatar = (props) => {
    const { user } = useUser();
    const { getInitials } = useUserFields();

    const [picture, setPicture] = React.useState(null);

    useEffect(() => {
        if (user.auth0Details) {
            setPicture(user.auth0Details.picture);
        }
    }, [user.auth0Details]);

    if (user) {
        return (
            <StyledAvatar
                src={picture}
                alt={getInitials()}
                data-analyticsid='avatar'
                {...props}
            />
        );
    } else {
        return <StyledAvatar data-analyticsid='avatar' />;
    }
};
